<template>
  <div class="pd-b-10 bg-white mg-y-10">
    <div class="d-flex align-items-center mg-b-20">
      <label
        class="
          tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans
          mg-t-5 mg-l-5
        "
        >{{ f.title }}</label
      >
      <a
        @click="$emit('on-site-add', 505)"
        role="button"
        class="btn btn-outline-success btn-xs mg-l-auto mg-t-10 mg-r-5"
        >Шинэ</a
      >
    </div>
    <nav class="nav nav-sidebar tx-13">
      <div>
        <div class="pd-x-10-f pd-y-0-f mg-b-20">
          <div class="form-group">
            <div>
              <label class="mg-b-0 text-uppercase tx-10"
                >{{ f.title }} хайх</label
              >
            </div>
            <input
              v-model="siteSearchField"
              type="text"
              placeholder=""
              class="form-control form-control-sm"
            />
          </div>
        </div>
      </div>
      <section
        v-for="(s, i) in sites.filter(
          x =>
            x.code.toLowerCase().indexOf(siteSearchField.toLowerCase()) > -1 ||
            x.name.toLowerCase().indexOf(siteSearchField.toLowerCase()) > -1
        )"
        :key="i"
      >
        <a
          @click="loadSite(s)"
          role="button"
          class="nav-link"
          :class="{
            active:
              siteCurObj.rdy &&
              siteCurObj.site != null &&
              siteCurObj.site.id == s.id
          }"
        >
          <feather
            v-if="
              siteCurObj.rdy &&
                siteCurObj.site != null &&
                siteCurObj.site.id == s.id
            "
            type="chevron-right"
            class="wd-20-f ht-20-f mg-r-5"
          ></feather>
          <feather
            v-else
            type="folder"
            class="wd-20-f ht-20-f mg-r-5"
          ></feather>
          <span
            ><b>{{ s.code.replace("Loc-", "") }}</b> {{ s.name }}</span
          >
          <!-- <a @click.stop="deselectSite(s)" v-if="siteCurObj.rdy && siteCurObj.site!=null && siteCurObj.site.id==s.id" class="btn btn-xs btn-icon mg-l-auto btn-outline-danger btn-site-remove">
            <feather type="x" class="wd-20-f ht-20-f"></feather>
          </a>-->
          <Dropdown
            trigger="click"
            size="small"
            class="mg-l-auto"
            @command="siteCommand(s, $event)"
          >
            <a class @click.stop>
              <feather type="chevron-down" class></feather>
            </a>
            <DropdownMenu slot="dropdown">
              <DropdownItem command="detailsite">Дэлгэрэнгүй</DropdownItem>
              <DropdownItem command="editsite">Засах</DropdownItem>
              <DropdownItem command="additem" divided
                >Тоног төхөөрөмж бүртгэх</DropdownItem
              >
            </DropdownMenu>
          </Dropdown>
        </a>
        <!-- @node-click="siteChange" -->
        <Tree
          v-if="
            siteCurObj.rdy &&
              siteCurObj.site != null &&
              siteCurObj.site.id == s.id
          "
          ref="folterTree"
          node-key="id"
          node-key1="label"
          :key="treeKey"
          :data="siteCurObj.list"
          @node-contextmenu="siteDetail"
          :expand-on-click-node="false"
          accordion
          class="manual-tree"
          :current-node-key="selectedAssetId"
          :default-expanded-keys="expandKeys"
        >
          <div
            @click="siteChange(node.key)"
            slot-scope="{ node }"
            class="d-flex align-items-center wd-100p"
          >
            <div class="tx-color-02">{{ node.label }}</div>
            <Dropdown
              trigger="click"
              size="small"
              class="mg-l-auto"
              @command="itemCommand(node.key, $event)"
            >
              <a class="btn btn-xs btn-light btn-icon" @click.stop>
                <feather type="menu" class></feather>
              </a>
              <DropdownMenu slot="dropdown">
                <DropdownItem command="detailitem">Дэлгэрэнгүй</DropdownItem>
                <DropdownItem command="additem">Төхөөрөмж бүртгэх</DropdownItem>
                <DropdownItem command="edititem">Засах</DropdownItem>
                <DropdownItem command="addwork" divided
                  >Ажлын захиалга бүртгэх</DropdownItem
                >
              </DropdownMenu>
            </Dropdown>
          </div>
        </Tree>
      </section>
    </nav>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
const moment = require("moment");
var LTT = require("list-to-tree");
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import {
  Cascader,
  Tree,
  Dropdown,
  DropdownMenu,
  DropdownItem
} from "element-ui";

export default {
  components: {
    Cascader,
    Tree,
    Dropdown,
    DropdownMenu,
    DropdownItem
  },
  props: {
    f: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      sites: [],
      siteSearchField: "",
      siteCurObj: {
        site: null,
        list: [],
        listFlat: [],
        rdy: false
      },
      selectedAssetId: null,
      treeKey: 0,
      expandKeys: []
    };
  },
  mounted() {
    this.init();
  },
  updated() {},
  methods: {
    init(e, id, parentId) {
      request({
        api: { method: "GET", url: "asset/siteList" },
        //data: { invoiceId: this.t.id, desc: desc },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.sites = res.data.list;
          //console.log('asset/siteList', res);
          if (e != undefined) {
            let _cur = this.sites.filter(x => x.id == e);
            if (_cur.length) {
              this.loadSite(_cur[0], id, parentId);
            }
          }
        }
      });
    },
    loadSiteFromSearch(e, id, parentId) {
      this.init(e, id, parentId);
    },
    setExpand() {
      let me = this.siteCurObj.listFlat.filter(
        x => x.id == this.selectedAssetId
      );
      if (me.length > 0) {
        let parent = this.siteCurObj.listFlat.filter(
          x => x.id == me[0].parentId
        );
        this.expandKeys = [];
        this.$nextTick(() => {
          if (parent.length > 0) this.expandKeys = [parent[0].id, me[0].id];
          else this.expandKeys = [me[0].id];
        });
      }
    },
    loadSite(site, id, parentId) {
      this.siteCurObj.rdy = false;
      request({
        api: { method: "GET", url: "asset/ItemsBySiteId" },
        params: { id: site.id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.siteCurObj.listFlat = res.data.list;

          var ltt = new LTT(this.siteCurObj.listFlat, {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children"
          });

          this.siteCurObj.list = ltt.GetTree();
          this.siteCurObj.site = site;
          this.selectedAssetId = id;

          this.siteCurObj.rdy = true;
          this.treeKey++;
          this.setExpand();
          if (parentId != undefined) {
            this.siteChange(parentId);
          } else {
            this.$emit("on-site", site.id);
          }
          //gadna tohooromjoor load hiiged site hevleh
        }
      });
    },
    deselectSite(s) {
      this.siteCurObj.rdy = false;
    },
    siteChange(e) {
      //console.log('siteChange=> ', e);
      //this.$emit('on-change', e.id)
      this.$emit("on-change", e);
    },
    siteDetail(e, n) {
      let _row = this.siteCurObj.listFlat.filter(x => x.id == n.id);
      if (_row.length > 0) {
        this.$emit("on-item-detial", _row[0]);
      }
    },
    siteCommand(e, mode) {
      switch (mode) {
        case "editsite":
          this.$emit("on-site-edit", e);
          break;
        case "detailsite":
          this.$emit("on-site-detail", e);
          break;
        case "additem":
          this.$emit("on-add-item-root", e);
          break;
        default:
          break;
      }
      //console.log(e, mode);
    },
    itemCommand(e, mode) {
      if (mode == "edititem") {
        let _row = this.siteCurObj.listFlat.filter(x => x.id == e);
        //console.log(_row);
        //let _row2 = this.siteCurObj.listFlat.filter(x => x.id == _row[0].parentId);
        this.$emit("on-edit-item", _row[0]);
      } else {
        let _row = this.siteCurObj.listFlat.filter(x => x.id == e);

        if (_row.length) {
          switch (mode) {
            case "additem":
              this.$emit("on-add-item", _row[0]);
              break;
            case "detailitem":
              this.$emit("on-item-detial", _row[0]);
              break;
            case "addwork":
              this.$emit("on-add-work", _row[0]);
              break;
            default:
              break;
          }
        }
      }
    }
  }
};
</script>
<style lang="scss">
.nav-sidebar {
  .nav-link {
    .btn-site-remove {
      padding: 0 2px;
      width: 25px;
      i {
        color: #dc3545 !important;
        svg {
          color: #dc3545 !important;
        }
      }
    }
  }
}
</style>
